import React, { useState } from 'react';
import Loader from '../../Components/Loader';
import SubHeader from '../../Components/Customer/SubHeader';
import Header from '../../Components/Customer/Header';
import Login from '../../Components/Customer/Login';
import useToken from '../../Components/Customer/useToken';
import useAccount from '../../Components/Customer/useAccount';
import { useNavigate } from "react-router-dom";
import Steps from '../../Components/Customer/Inspection/Steps';

function InspectionHome(props) {
  let navigate = useNavigate();
  const { account, setAccount } = useAccount();
  const { token, setToken } = useToken();
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("All Services");
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);  
  const [selectedInspection, setSelectedInspection] = useState();
  const [bookedInspections, setBookedInspections] = useState(null);
  const [serviceType, setServiceType] = useState(null);
  const [areaofService, setAreaofService] = useState('both');
  const [activeStep, setActiveStep] = useState(1);

  const changAareaofService = (area) => {
    console.log('Selected area:', area);
    setAreaofService(area);
  };

  const handleUndoSelectedInspection = () => {
    setSelectedInspection(null);
  };

  const steps = [
    {
      label: 'Service',
      step: 1,
    },
    {
      label: 'Booking',
      step: 2,
    },
    {
      label: 'Options',
      step: 3,
    },
    {
      label: 'Confirm',
      step: 4,
    },
  ];

  if (!token || !account) {
    return <Login setToken={setToken} setAccount={setAccount} />;
  }
 
  const logout = () => {
    setToken('');
    setAccount('');
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("account_details");
  };

  // Filter services by tab and search
  const filteredServices = props.globalServiceTypes
    ? props.globalServiceTypes.filter(s => {
        if (!s.type || !s.type.includes('inspection')) return false;
        if (s.key === 'ac-qd') return false;
        if (activeTab !== "All Services" && s.category !== activeTab) return false;
        if (search && !s.label.toLowerCase().includes(search.toLowerCase())) return false;
        return true;
      })
    : [];

  // Dynamically generate category tabs from available filtered services
  const inspectionServices = props.globalServiceTypes
    ? props.globalServiceTypes.filter(s => s.type && s.type.includes('inspection'))
    : [];
  const uniqueCategories = Array.from(new Set(inspectionServices.map(s => s.category))).filter(Boolean);
  const serviceTabs = ["All Services", ...uniqueCategories];

  // Selection logic (single selection)
  const selectCard = key => {
    setSelected([key]);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header clickLogout={logout}
        serviceType={null}
        globalServiceTypes={props.globalServiceTypes}
        setServiceType={() => {}}
        account={account}
      />
      <SubHeader account={account}
        serviceType={null}
        key={account.primary_property_id} />
        {(loading) && <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"><Loader /></div>}
   

  {/* Step Begin */}
      <section id="header-section" className=" bg-slate sm:max-w-full">
        <div className="container mx-auto  px-4">

          <Steps selected={activeStep}
          selectedInspection={selectedInspection} 
          serviceType={serviceType}
          globalServiceTypes={props.globalServiceTypes}
          areaofService={areaofService}
          setAreaofService={changAareaofService}
          items={steps}
          undoSelectedInspection={handleUndoSelectedInspection}
           />
        </div>
      </section>
      {/* Step End */}

      <div className="container mx-auto py-10 mt-6 px-4">
        <h2 className="text-2xl font-normal text-light mb-6">Select Services for Inspection</h2>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-4">
          <input
            type="text"
            placeholder="Search Services"
            className="border border-gray-300 rounded px-4 py-2 w-full md:w-1/3"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <div className="flex gap-2">
            {serviceTabs.map(tab => (
              <button
                key={tab}
                className={`px-4 py-2 rounded-full border text-sm font-medium transition-all ${activeTab === tab ? "bg-danger text-white" : "bg-white text-gray-700 border-gray-300"}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {filteredServices.map(inspection => (
            <div
              key={inspection.key}
              className={`bg-white rounded-lg shadow-sm transition-all flex flex-col justify-between relative cursor-pointer p-6 ${selected[0] === inspection.key ? "border-2 border-red-400" : "border border-gray-200"}`}
              onClick={() => selectCard(inspection.key)}
              style={{ minHeight: '170px' }}
            >
              <div className="mb-3">
                <h3 className="font-semibold text-lg mb-2">{inspection.label}</h3>
                <p className="text-gray-600 text-sm mb-6 leading-relaxed">{inspection.description}</p>
              </div>
              <div className="text-xs text-gray-400 font-medium pt-3 mt-auto border-t border-gray-100">{inspection.inspection_duration} approximately</div>
            </div>
          ))}
        </div>

        {/* Button row at bottom right */}
        <div className="flex items-center justify-end pt-6 mt-6">
          <div className="flex flex-col items-end">
            <button
              className={`w-64 bg-danger text-white py-3 rounded-lg text-lg font-semibold shadow-sm hover:bg-danger/80 transition mb-2 ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={selected.length === 0}
              onClick={() => {
                if (selected.length > 0) {
                  navigate(`/inspection/${selected[0]}`);
                }
              }}
            >
              Continue
            </button>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default InspectionHome;